import Vue from 'vue';
import CompaniesAutocompleteSearchQuery from './apollo/CompaniesSearch.query.gql';
import CreateCompanyMutation from './apollo/CreateCompany.mutation.gql';
import type {
  CreateCompanyMutation as CreateCompanyMutationType,
  CreateCompanyMutationVariables,
  CompaniesAutocompleteSearchQuery as CompaniesAutocompleteSearchQueryType,
  CreateCustomCompanyInput,
} from '~/types/graphql';

export type AutocompleteCompany = NonNullable<CreateCompanyMutationType['createCustomCompany']>;

interface IData {
  companiesSearchQuery: string;
  companiesSearch: Array<AutocompleteCompany>;
  newCompany: AutocompleteCompany | undefined;
}
const CompaniesAutocompleteMixin = Vue.extend({
  name: 'CompaniesAutocompleteMixin',
  apollo: {
    companiesSearch: {
      query: CompaniesAutocompleteSearchQuery,
      debounce: 100,
      variables() {
        // @ts-ignore
        return { query: this.companiesSearchQuery };
      },
    },
  },
  data(): IData {
    return {
      companiesSearchQuery: '',
      companiesSearch: [],
      newCompany: undefined,
    };
  },
  computed: {
    companies(): Array<AutocompleteCompany> {
      return this.companiesSearch;
    },
  },
  methods: {
    searchCompanies(query: string): void {
      if (!query || !query.trim() || query.length < 2) {
        this.companiesSearchQuery = '';
        return;
      }
      this.companiesSearchQuery = query;
    },
    async createCompany(input: CreateCustomCompanyInput): Promise<AutocompleteCompany | undefined> {
      try {
        await this.$apollo.mutate<CreateCompanyMutationType, CreateCompanyMutationVariables>({
          mutation: CreateCompanyMutation,
          variables: { input },
          update: (cache, { data }) => {
            if (!data?.createCustomCompany) return;
            const newCompany = data.createCustomCompany;
            this.newCompany = newCompany;

            const companiesAutocompleteSearchQuery = {
              query: CompaniesAutocompleteSearchQuery,
              variables: { query: newCompany.name },
            };
            const result = cache.readQuery<CompaniesAutocompleteSearchQueryType>(companiesAutocompleteSearchQuery);
            if (result) {
              const companies = result.companiesSearch;
              companies.push(newCompany);
              cache.writeQuery({ ...companiesAutocompleteSearchQuery, data: { companiesSearch: companies } });
            }
          },
        });
        return this.newCompany;
      } catch (e) {
        this.$notice.error('Could not create new company', e);
        this.$sentryUtils.error(e);
      }
    },
  },
});

export default CompaniesAutocompleteMixin;
